import { Registration } from 'interfaces/slide';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
import { CasesParams } from 'utils/useCasesParams/types';

export const getSlideRegistrations = (caseParams: CasesParams) => {
  return apiRequestHandlerPromise<Registration[]>({
    url: `slide_registrations.get`,
    method: 'POST',
    data: JSON.stringify(caseParams),
  });
};
